export const ApiRoutes = {
  userState: {
    getUserTaskState: (userId: string): string => `facade/v1/portal/users/${encodeURIComponent(userId)}/task-state`,
  },
};
